<template>      
  <div class="wrapper">
    <div class="container">
      <md-card class="customCard navbar-margin">
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="tim-typo">
                <h2 class="title">Ausstellung</h2> 
                <p>Unsere Ausstellung ist immer Dienstags und Donnerstags von 8.00 bis 16:30 Uhr für Sie geöffnet.</p>
              </div>
              <div class="gallery">
                <div class="gallery-panel">
                  <img
                  :src="ausstellung1"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
                <div class="gallery-panel">
                  <img
                  :src="ausstellung2"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
                <div class="gallery-panel">
                  <img
                  :src="ausstellung3"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
                <div class="gallery-panel">
                  <img
                  :src="ausstellung4"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
                <div class="gallery-panel">
                  <img
                  :src="ausstellung5"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
                <div class="gallery-panel">
                  <img
                  :src="ausstellung6"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
		<div class="gallery-panel">
                  <img
                  :src="ausstellung7"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
		<div class="gallery-panel">
                  <img
                  :src="ausstellung8"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>
		<div class="gallery-panel">
                  <img
                  :src="ausstellung9"
                  class="rounded z-depth-1-half"
                  :class="{ 'responsive-image': responsive }"/>
                </div>

              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ausstellung',
  props: {
    msg: String
  },
  data() {
    return {
        ausstellung1: require("@/assets/images/Ausstellung/ausstellung1.jpg"),
        ausstellung2: require("@/assets/images/Ausstellung/ausstellung2.jpg"),
        ausstellung3: require("@/assets/images/Ausstellung/ausstellung3.jpg"),
        ausstellung4: require("@/assets/images/Ausstellung/ausstellung4.jpg"),
        ausstellung5: require("@/assets/images/Ausstellung/ausstellung5.jpg"),
        ausstellung6: require("@/assets/images/Ausstellung/ausstellung6.jpg"),
	ausstellung7: require("@/assets/images/Ausstellung/ausstellung7.jpg"),
	ausstellung8: require("@/assets/images/Ausstellung/ausstellung8.jpg"),
	ausstellung9: require("@/assets/images/Ausstellung/ausstellung9.jpg")
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
